import { money } from "@/lib/format";
import { getRuntimeLanguage } from "@/i18n/core";
import { translateKey } from "@/i18n/registry";

export function getPotentialSale(customer, language = getRuntimeLanguage()) {
  const numericValue = Number(customer?.value);
  const hasValue = customer?.value !== null
    && customer?.value !== undefined
    && customer?.value !== ""
    && Number.isFinite(numericValue);

  return {
    amount: hasValue ? numericValue : 0,
    hasValue,
    source: customer?.valueSource || "review",
    basis: customer?.valueBasis || translateKey(
      hasValue ? "commercial.currentValueUnattributed" : "commercial.potentialNotEntered",
      {},
      language,
    ),
  };
}

export function potentialSaleText(sale, language = getRuntimeLanguage()) {
  return sale?.hasValue ? money(sale.amount, language) : translateKey("commercial.notSet", {}, language);
}

export function getCommercialPicture(customer, language = getRuntimeLanguage()) {
  const potential = getPotentialSale(customer, language);
  const commercial = customer?.commercial || {};
  const spent = Number(commercial.spent);
  const openValue = Number(commercial.openValue);
  const lifetimeValue = commercial.lifetimeValue === null || commercial.lifetimeValue === undefined
    ? null
    : Number(commercial.lifetimeValue);
  return {
    potential,
    spent: Number.isFinite(spent) ? spent : 0,
    spentSource: commercial.spentSource || "imported",
    openValue: Number.isFinite(openValue) ? openValue : potential.amount,
    openSource: commercial.openSource || potential.source,
    lifetimeValue: Number.isFinite(lifetimeValue) ? lifetimeValue : null,
    lifetimeSource: commercial.lifetimeSource || "estimate",
    lifetimeBasis: commercial.lifetimeBasis || translateKey("commercial.notEnoughHistory", {}, language),
  };
}
